export default {
  freightSourceShipownerTitle: '船东',
  freightSourcePeerTitle: '同行',
  freightSourceAgentPriceTitle: '代理约价',
  exportUserTitle: '导出人',
  exportStatusTitle: '导出状态'
}
